import React, { useEffect } from "react";
import styled from "styled-components";
import i18n from "i18next";
import Spinner from "components/loader/Spinner";
import PrimaryButton from "components/button/PrimaryButton";
import kuberaLogo from "assets/images/kubera_logo.svg?react";
import { isAppInWhiteLabelMode, isMobile } from "@kubera/common";
import { useErrorBoundary } from "react-error-boundary";

const isMobileDevice = isMobile();

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: ${props => (isMobileDevice ? props.theme.mobileBackground : props.theme.initialLoaderBG)};
`;

const SpinIt = styled(Spinner)`
  width: 1.25rem;
  height: 1.25rem;
`;

const ErrorMessage = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  text-align: center;
  color: ${props => props.theme.mobileTxtColor};
  white-space: pre-wrap;
`;

const RefreshButton = styled(PrimaryButton)`
  height: 2.75rem;
  margin-top: 0.9375rem;
`;

const Logo = styled(kuberaLogo)`
  margin-bottom: 0.6875rem;
  width: 6.0625rem;
  height: 1.5rem;
  path {
    fill: ${props => props.theme.mobileTxtColor};
  }
`;

let timeoutId = null;
function InitialLoader({
  className = "",
  errorMessage,
  hideLogo,
  disableRefresh,
  overrideGenericError,
  throwExceptionIfTimeout = false,
  onRefresh = () => null
}) {
  const isWhiteLabelledApp = isAppInWhiteLabelMode();
  const { showBoundary } = useErrorBoundary();

  useEffect(() => {
    if (throwExceptionIfTimeout) {
      timeoutId = setTimeout(() => {
        showBoundary("InitialLoader timeout error");
      }, 50000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [showBoundary, throwExceptionIfTimeout]);

  if (errorMessage) {
    return (
      <Container className={className}>
        {isWhiteLabelledApp === false && !hideLogo === true && <Logo />}
        <ErrorMessage
          dangerouslySetInnerHTML={{
            __html: !overrideGenericError === false ? errorMessage : i18n.t("genericError")
          }}
        ></ErrorMessage>
        {!disableRefresh === true && <RefreshButton title={i18n.t("refresh")} onClick={onRefresh} />}
      </Container>
    );
  } else {
    return (
      <Container className={className}>
        {isWhiteLabelledApp === false && !hideLogo === true && <Logo />}
        <SpinIt darkTheme={true} isHorizontalLoader />
      </Container>
    );
  }
}

export default InitialLoader;
